<template>
  <div class="row">
    <div class="col_12">
      <div class="card no_border">
        <div class="card-header">
          <div class="card-title">{{ $t('sidebar.exams.exams') }}</div>
        </div>
        <div class="card-body pl_0 pr_0">
          <div class="row mt_10">
            <div class="col_2">
              <div class="form-group ">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span> {{ filter.lecture != '' && lectures.length ? lectures.find(s=> s.id === parseInt(filter.lecture)).name : $t('sidebar.exams.lecture') }}</span>
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li @click="lectureFilter('')"><a role="button">{{ $t('common.all') }}</a></li>
                        <li @click="lectureFilter(lecture.id)" v-for="lecture in lectures" :key="'lecture'+lecture.id"><a role="button">{{ lecture.name }}</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col_1">
              <div class="form-group ">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span> {{ filter.examType != '' && examTypes.length ? examTypes.find(s=> s.id === parseInt(filter.examType)).name : $t('sidebar.exam_type.exam_type') }}</span>
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li @click="examTypeFilter('')"><a role="button">{{ $t('common.all') }}</a></li>
                        <li @click="examTypeFilter(examType.id)" v-for="examType in examTypes" :key="'examType'+examType.id"><a role="button">{{ examType.name }}</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="col_1">
              <div class="form-group ">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span> {{ filter.grade != '' && grades.length ? grades.find(s=> s.id === parseInt(filter.grade)).name : $t('common.grade') }}</span>
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li @click="gradeFilter(grade.id)" v-for="grade in grades" :key="'grade'+grade.id"><a role="button">{{ grade.name }}</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_1">
              <div class="form-group ">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span> {{ filter.semester != '' && semesters.length ? semesters.find(s=> s.id === parseInt(filter.semester)).name : $t('common.semester') }}</span>
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li @click="semesterFilter(semester.id)" v-for="semester in semesters" :key="'semester'+semester.id"><a role="button">{{ semester.name }}</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <Multiselect
                  v-model="filter.unit"
                  :placeholder="$t('common.select_unit')"
                  :caret="false"
                  :close-on-select="false"
                  :searchable="true"
                  :create-option="true"
                  :hideSelected="false"
                  :options="units"
                  @select="unitFilter()"
                />
              </div>
            </div>
            <!-- <div class="col_2">
              <div class="form-group ">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span> {{ filter.unit != '' && units.length ? units.find(s=> s.id === parseInt(filter.unit)).unit_name : $t('common.unit') }}</span>
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li @click="unitFilter(unit.id)" v-for="unit in units" :key="'unit'+unit.id"><a role="button">{{ unit.unit_name }}</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="col_1">
              <div class="form-group ">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>{{ filter2.scope }}</span>
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li><a role="button" @click="changeScope('all')">{{ $t('common.all') }}</a></li>
                        <li @click="changeScope('one')"><a role="button">*</a></li>
                        <li @click="changeScope('two')"><a role="button">**</a></li>
                        <li @click="changeScope('three')"><a role="button">***</a></li>
                        <li @click="changeScope('four')"><a role="button">****</a></li>
                        <li @click="changeScope('five')"><a role="button">*****</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_1">
                <div class="form-group ">
                    <div class="d_flex_start">
                        <div class="dropdown custom_dropdown mr_10">
                            <button class="btn">
                                <span> {{ filter.placement != '' && placements.length ? placements.find(s=> s.id === parseInt(filter.placement)).placement_name : '배치고사' }}</span>
                            </button>
                            <div class="dropdown_menu">
                                <ul>
                                    <li @click="placementFilter(placement.id)" v-for="placement in placements" :key="'placement'+placement.id"><a role="button">{{ placement.placement_name }}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col_4">
              <div class="form-group">
                <div class="d_flex_end">
                  <div class="form_row_inline">
                    <input type="text" class="form_global" :placeholder="$t('common.search')" v-model="queryParams.search">
                  </div>
                  <div class="form_row_inline ml_10">
                    <div class="btn btn_common_type_2 mr_10 width_150p" @click="queryParams.page = 1 ; searchQuery()">{{ $t('common.search') }}</div>
                    <div class="btn btn_secondary width_150p" @click="resetAll()">{{ $t('common.reset') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_12 ">
              <div class="separator pl_0 pr_0">
                <span></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_12">
              <div class="d_flex_btwn pt_20 pb_20">
                <div class="d_flex_start col_2 pl_0">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>{{ filter.per_page }}</span>
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li @click="changePerPageFilter(10)"><a role="button">10</a></li>
                        <li @click="changePerPageFilter(20)"><a role="button">20</a></li>
                        <li @click="changePerPageFilter(50)"><a role="button">50</a></li>
                        <li @click="changePerPageFilter(100)"><a role="button">100</a></li>
                        <li @click="changePerPageFilter(200)"><a role="button">200</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="d_flex_end col_10 pr_0">
                  <router-link :to="{ name: 'exam_management_exam_add'}" class="btn btn_transparent">{{ $t('sidebar.exams.add_exam') }}</router-link>
                </div>
              </div>
            </div>
          </div>
          <table-component
              :columns="columns"
              :rows="exams"
              :pagination="pagination"
              @sorting="sorting"
              :sortable="sortable"
              @pageChanged="pageChanged">
              <template #exam_time="{ row }">
                  <p v-if="row.exam_time">{{ row.exam_time }} {{ $t('sidebar.lectureCommon.minute') }}</p>
              </template>
              <template #action="{ row }">
                <div class="d_flex_center table_action_btn">
                  <router-link :to="{name: 'exam_management_exam_edit', params:{id: row.id}}" :title="$t('common.edit')" class="btn btn_blue ml_10">
                    <img :src="`${baseUrl}assets/media/images/icon/8.png`" alt="">
                  </router-link>
                  <button class="btn btn_danger ml_10" :title="$t('common.delete')" @click.prevent="deleteRecord(row)">
                    <img :src="`${baseUrl}assets/media/images/icon/9.png`" alt="">
                  </button>
                </div>
              </template>
          </table-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "@/components/shared/TableComponent";
import Multiselect from '@vueform/multiselect'
export default {
  components: { TableComponent, Multiselect },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      exams: [],
      lectures: [],
      // examTypes: [],
      semesters: [],
      grades: [],
      units: [],
      placements: [{
              id: 1,
              placement_name: 'Yes',
          },
          {
              id: 2,
              placement_name: 'No',
          }
      ],
      filter: {
        lecture: '',
        // examType: '',
        grade: '',
        semester: '',
        unit: '',
        scope: '',
        per_page: 20,
        placement: '',
      },
      filter2:{
        scope: this.$t('sidebar.unitManagement.scope')
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'title',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20
      },
      pagination: null,
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },

      columns: [
        {
          label: this.$t('common.title'),
          field: "title",
          sortable: true
        },
        {
          label: this.$t('common.grade'),
          field: "grade.name",
          sortable: true
        },
        {
          label: this.$t('common.subject'),
          field: "subject.name",
          sortable: true
        },
        // {
        //   label: this.$t('sidebar.exam_type.exam_type'),
        //   field: "examType.name",
        //   sortable: true
        // },
        {
          label: this.$t('common.area'),
          field: "area.name",
          sortable: true
        },
        {
          label: this.$t('sidebar.exams.exam_time'),
          field: "exam_time",
          sortable: true,
          slot: true
        },
        {
          label: this.$t('common.action'),
          field: 'action',
          sortable: false,
          slot: true,
        }
      ],
    }
  },
  watch: {
    $route(to, from) {
      if(to.name == from.name && !window._.isEqual(to, from)){
        this.setQueryData(this.getAllQueryParams())
        this.loadData()
      }
    },
  },
  created() {
    const query = this.getAllQueryParams()
    if(query.page){
      this.setQueryData(query)
    }

    this.axios.get('/lectures').then((response) => this.lectures = response.data.data);
    // this.axios.get('/exam-types').then((response) => this.examTypes = response.data.data);
    this.axios.get('/grades').then((response) => this.grades = response.data.data);
    this.axios.get('/semesters').then((response) => this.semesters = response.data.data);

    this.axios.get('/units').then((response) => {
        response.data.data.forEach(element => {
            let unit = {
              'value' : element.id,
              'label' : element.unit_name
            }
            this.units.push(unit)
        });
    })

    // this.axios.get('/units').then((response) => this.units = response.data.data);

    this.loadData();
  },
  methods: {
    setQueryData(query){
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        lecture: query.lecture,
        // examType: query.examType,
        grade: query.grade,
        semester: query.semester,
        unit: query.unit,
        scope: query.scope,
        placement: query.placement,
        per_page: query.per_page
      }
      this.sortable = {
        order:  query.sort,
        sort: query.sort_order
      }
    },
    lectureFilter(id){
      this.filter.lecture = id
      this.changeRoute();
    },
    // examTypeFilter(id){
    //   this.filter.examType = id
    //   this.changeRoute();
    // },
    semesterFilter(id){
      this.filter.semester = id
      this.changeRoute()
    },
    gradeFilter(id){
      this.filter.grade = id
      this.changeRoute()
    },
    unitFilter(){
      // this.filter.unit = id
      this.changeRoute()
    },
    placementFilter(id) {
        this.filter.placement = id
        this.changeRoute()
    },
    changeScope(scope){
      if(scope == 'all'){
        this.filter.scope = ''
        this.filter2.scope = this.$t('common.all')
      }else{
        let scopeName = ''
        if(scope == 'one'){
          scopeName = '*'
        }else if(scope == 'two'){
          scopeName = '**'
        }else if(scope == 'three'){
          scopeName = '***'
        }else if(scope == 'four'){
          scopeName = '****'
        }else{
          scopeName = '*****'
        }

        this.filter.scope = scope
        this.filter2.scope = scopeName
      }
      this.changeRoute()
    },
    changePerPageFilter(per_page){
      this.filter.per_page = per_page
      this.changeRoute();
    },
    resetAll(){
      this.sortable = {
        order: 'created_at',
        sort: 'desc'
      }
      this.filter = {
        lecture: '',
        // examType: '',
        grade: '',
        semester: '',
        unit: '',
        scope: '',
        placement: '',
        per_page: 20
      }

      this.filter2 = {
        scope: this.$t('sidebar.unitManagement.scope')
      }

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'title',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery(){
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.axios.get('/exams', {
        params: {...this.queryParams, ...this.filter}
      }).then((response) => {
        this.exams = response.data.data;
        this.pagination = response.data.meta;
      })
    },
    deleteRecord(row) {
      this.$swal({
        title: this.$t('common.deleteConfirmation'),
        text: this.$t('common.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.yesDelete'),
        cancelButtonText: this.$t('common.noCancel'),
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/exams/'+row.id).then(() => {
            this.loadData();
            this.$swal.fire(
                this.$t('common.deleted'),
                this.$t('common.deleteMessage'),
                'success'
            )
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.search_btn{
  padding: 10px 10px 10px 15px;
  margin: 0px 10px 0px 0px;
}

.reset_btn{
  padding: 10px 10px 10px 15px;
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style>